<template>
 <div class="dib">
   <Tooltip :content="$t(_tip)" placement="top">
       <i class="icon tool" :class="[_iconClass]">
         <slot></slot>
       </i>
    </Tooltip>
</div>
</template>

<script>

const ICON_TIP_MAPP = {
  up: 'iconUp',
  down: 'iconDown',
  add: 'iconAdd',
  edit: 'iconEdit',
  delete: 'iconDelete',
  remove: 'iconDelete',
  config: 'iconConfig',
  copy: 'iconCopy',
  save: 'iconSave',
  cancel: 'iconCancel',
  uploadImage: 'iconUploadImage'
}

const ICON_CLASS_MAPP = {
  add: 'icon-add',
  edit: 'icon-edit',
  delete: 'icon-delete',
  remove: 'icon-remove',
  config: 'icon-config',
  copy: 'icon-copy',
  save: 'icon-save',
  cancel: 'icon-cancel',
  uploadImage: 'icon-upload-image'
}

export default {
  name: 'ipsosIcon',
  props: ['iconClass', 'tip', 'type', 'plugin'],
  data () {
    return {

    }
  },
  components: {

  },
  watch: {
  },
  computed: {
    _iconClass () {
      return this.iconClass || ICON_CLASS_MAPP[this.type]
    },
    _tip () {
      return this.tip || ICON_TIP_MAPP[this.type]
    }
  },
  methods: {
  },
  created () {

  },
  mounted () {

  }
}
</script>
<style lang="scss">
.icon-remove {
  width: 21px;
  height: 20px;
  background: url(../../assets/images/icon/ico-delete@2x.png);
}

.icon-edit {
  width: 20px;
  height: 20px;
  background: url(../../assets/images/icon/ico-edit@2x.png);
}

.icon-delete {
  width: 21px;
  height: 20px;
  background: url(../../assets/images/icon/ico-delete@2x.png);
}

.icon-config {
  width: 21px;
  height: 20px;
  background: url(../../assets/images/icon/peizhi.png);
}

.icon-copy {
  width: 21px;
  height: 20px;
  background: url(../../assets/images/icon/ico-copy@2x.png);
}
</style>



// WEBPACK FOOTER //
// src/plugin/element/DubuIcon.vue